import { render, staticRenderFns } from "./AccountProblemLogoutButton.vue?vue&type=template&id=143e1e9a&scoped=true&"
import script from "./AccountProblemLogoutButton.vue?vue&type=script&lang=js&"
export * from "./AccountProblemLogoutButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e1e9a",
  null
  
)

export default component.exports